import cn from 'classnames';
import React from 'react';
import {useSelector} from 'react-redux';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import ModalTypes from '../../enums/app/modalTypes';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import modalService from '../../services/modalService';
import productService from '../../services/product/productService';
import appRouterService from '../../services/route/appRouterService';
import {setIsSkipRegistration} from '../../state/ducks/global';
import {selectIsStartAutoSync} from '../../state/selectors/global';
import {selectIotDeviceData} from '../../state/selectors/iotDevice';
import {dispatch} from '../../state/store';
import elementsTesIds from '../../test/consts/elementsTesIds';
import helpers from '../../utils/helpers';
import {AppButton} from '../Button';
import ConnectionTrackButton from '../Button/ConnectionTrackButton/ConnectionTrackButton';

const SkipRegistrationButton = ({onSkipClick, className}) => {
    const isStartAutoSync = useSelector(selectIsStartAutoSync);
    const iotDevice = useSelector(selectIotDeviceData);
    const {device} = iotDevice || {};
    const {isP4} = device || {};
    const isSkipRegistrationEnabled = productService.isSkipRegistrationEnabled(isP4);

    if (!isSkipRegistrationEnabled) return null;

    const skipRegistration = async () => {
        dispatch(setIsSkipRegistration(true));
        await helpers.runFunction(onSkipClick);

        //hide holder reg popup if user wants to skip reg
        modalService.hideModal(ModalTypes.REGISTRATION_HOLDER);

        if (isStartAutoSync) return;

        appRouterService.forwardToDeviceSyncPage();
    };

    const classNames = cn('mt-4', className);

    return (
        <ConnectionTrackButton
            button={AppButton}
            className={classNames}
            secondary
            light
            onClick={skipRegistration}
            testId={elementsTesIds.PAIRING_SEQUENCE_REGISTRATION_FAILED_BTN_TRY_SKIP}
        >
            {getLocalizedStrings()[localizationKeys.REGISTRATION_FAILED_PROCEED_WITHOUT_REGISTRATION]}
        </ConnectionTrackButton>
    );
};

export default SkipRegistrationButton;
